import React, { useState } from 'react';
import { API_BASE_URL } from '../scripts/control';

const UserCreationModal = ({ onClose }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [mensaje, setMensaje] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Enviar los datos al endpoint de creación de usuario
    try {
      const response = await fetch(`${API_BASE_URL}/api/bd_create_user.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });

      const data = await response.json();
      if (data.success) {
        setMensaje('Usuario creado correctamente');
      } else {
        setMensaje(data.message || 'Error al crear el usuario');
      }
    } catch (error) {
      setMensaje('Ocurrió un error. Inténtalo nuevamente.');
    }
  };

  return (
    <div className="modal show" style={{ display: 'block' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title text-body">Crear Usuario</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body text-body">
            <form onSubmit={handleSubmit}>
              <label>Usuario:</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
              <br />
              <label>Contraseña:</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <br /><br />
              <button 
                style={{
                    backgroundColor: 'white',
                    border: '2px solid #005EC4',
                    borderRadius: '15px',
                    color: '#005EC4',
                    cursor: 'pointer',
                    padding: '10px',
                    textDecoration: 'none'
                }} type="submit">Crear Usuario</button>
            </form>
            {mensaje && <p>{mensaje}</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCreationModal;
